import { API_BASE_URL } from "@/config";
import LivenessCheck from '@/components/Verification/liveness_check/LivenessCheck.vue';
import { validate_id } from '@/utils/validations';

export default {
  name: 'FacialBiometrics',
  data: () => ({
    client_id: '',
    id_number: '',
    photo_src: '',
    get_consent: false,
    consent_provided: false,
    is_id_valid: false,
    showCamera: false,
    showInstructions: false,
    show_error: false,
    error_message: ''
  }),
  created() {
    this.consent_provided = localStorage.getItem('facial_biometrics_consent') === 'true';
  },
  components: {
    LivenessCheck
  },
  methods: {

     handle_close_camera() {
      this.showCamera = false;
    },
    
    validate_id_number() {
      this.is_id_valid = validate_id(this.id_number);
      return this.is_id_valid;
    },
    async id_check() {
      // Clear any existing error messages
      this.error_message = '';

      if (this.validate_id_number()) {
        const TOKEN = localStorage.getItem('token');
        const CONSENT_URL = `${API_BASE_URL}/verify_api/system_management_api/save_id_verification_api/`;
        const FORM_DATA = {
          id_number: this.id_number
        };

        $.ajax({
          url: CONSENT_URL,
          method: 'POST',
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          data: JSON.stringify(FORM_DATA),
          beforeSend: () => {
            this.error_message = '';
          },
          success: (response) => {
            this.error_message = ''; // Clear error message on success
            if (response.status === 'success') {
              localStorage.setItem('id_number', response.id_number);
              localStorage.setItem('user_state', 'id_verified');
              this.showInstructions = true;
            }
          },
          error: (error) => {
            if (error.responseJSON) {
              this.error_message = 'ID number already exists.';
            } else {
              this.error_message = error.responseJSON.message || 'Something went wrong!';
            }
          }
        });
      } else {
        this.error_message = 'Invalid ID number.';
      }
    },
    clear_error_message() {
      this.error_message = '';
      this.show_error = false;
    },
    set_photo_src(photo_src) {
      this.photo_src = photo_src;
      this.submit_photo();
    },
    async startFaceRecognition() {
      this.showCamera = false;
      this.showInstructions = false;

      this.$refs.liveness_check.unlockAudio();

      await new Promise(resolve => setTimeout(resolve, 100));

      this.showCamera = true;

      await this.$nextTick();

      try {
        await this.$refs.liveness_check.startFaceRecognition();
      } catch (error) {
        console.error("Error starting face recognition:", error);
        Swal.fire({
          icon: "error",
          text: "Unable to start facial recognition. Please try again.",
        });
        this.showCamera = false;
        this.showInstructions = true;
      }
    },
    start_liveness_check() {
      this.$refs.liveness_check.set_id_number(this.client_id);
    },
    get_terms_and_conditions() {
      const TOKEN = localStorage.getItem('token');
      const GET_TERMS_AND_CONDITIONS_API = `${API_BASE_URL}/verify_api/system_management_api/get_terms_and_conditions_api/`;
      //change url
      $.ajax({
        url: GET_TERMS_AND_CONDITIONS_API,
        method: 'GET',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {
          Swal.fire({
            text: 'Loading ...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        },
        success: (response) => {
          Swal.close();

          this.get_consent = response.get_consent;
          this.consent_provided = response.get_consent;

          // If consent is already provided, update localStorage
          if (response.get_consent) {
            localStorage.setItem('facial_biometrics_consent', 'true');
            localStorage.setItem('user_state', 'consent_given');
          }

        },
        error: () => {
          Swal.close();

        }
      });
    },
    accept() {
      const TOKEN = localStorage.getItem('token');
      const CONCENT_URL = `${API_BASE_URL}/verify_api/system_management_api/terms_and_conditions_api/`;

      const FORM_DATA = {
        consent_provided: true
      };

      $.ajax({
        url: CONCENT_URL,
        method: 'POST',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        data: JSON.stringify(FORM_DATA),
        beforeSend: () => {
          Swal.fire({
            text: 'Loading ...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        },
        success: () => {
          Swal.close();
          this.consent_provided = true; // Enable LivenessCheck
          localStorage.setItem('facial_biometrics_consent', 'true');
          localStorage.setItem('user_state', 'consent_given');
          // Hide the modal
          const modal = document.getElementById('terms_and_conditions_modal');
          if (modal) {
            modal.style.display = 'none';
          }
          this.$emit('consent-updated', true);
        },
        error: () => {
          Swal.close();
          Swal.fire({
            icon: 'error',
            text: 'Error saving consent. Please try again.'
          });
        }
      });
    },
    decline() {
      Swal.fire({
        title: 'Are you sure you want to decline?',
        text: "You cannot proceed with the application if consent is not provided.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.removeItem('token');
          localStorage.removeItem('user_state');
          this.$router.push('/');
        }
      });
    },
    show_popup() {
      const modal = document.getElementById('terms_and_conditions_modal');
      if (modal) {
        modal.style.display = 'block';
      }
    },
    hide_popup() {
      const modal = document.getElementById('terms_and_conditions_modal');
      if (modal) {
        modal.style.display = 'none';
      }
    },
    submit_photo() {
      const TOKEN = localStorage.getItem("token");
      const SAFPS_URL = `${API_BASE_URL}/verify_api/personnel_verification/facial_biometrics_liveness_verification/`;
      const DATA = {
        id_number: this.id_number,
        biometric: this.photo_src
      };

      Swal.fire({
        title: 'Verifying...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      $.ajax({
        url: SAFPS_URL,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(DATA),
        success: (response) => {
          Swal.close();
          var status_message = response.status;
          var liveness_value = response.liveness;
          var message = response.message;

          this.$refs.liveness_check.close_modal();

          if (status_message === "success") {
            localStorage.setItem('user_state', 'verified');
            this.$router.push('/company_verification');
            return;
          } else if (
            status_message ===
            "Results not found please contact your service provider"
          ) {
            Swal.fire({
              icon: "error",
              text: "Our service is currently unavailable. Please contact your service provider and try again later",
            });
          }
          if (liveness_value === 'User is wearing a hat') {
            liveness_value = "Please remove your hat and try again"
          }
          if (liveness_value === 'User is wearing glasses') {
            liveness_value = "Please remove your glasses and try again"
          }

          if (liveness_value) {
            Swal.fire({
              icon: "error",
              title: liveness_value,
            }).then(() => {
              location.reload();
            });
          }

          if (message) {
            Swal.fire({
              icon: "error",
              title: message,
            }).then(() => {
              location.reload();
            });
          }
        },
        error: (error) => {
          Swal.close();
          let error_message = "Error retrieving data";

          if (error.responseJSON) {
            error_message = error.responseJSON.id_number[0];
            $(".error-message")
              .text(error_message)
              .removeClass("d-none");
            setTimeout(() => {
              $(".error-message").text("").addClass("d-none");
            }, 3000);
          }
        },
      });
    },
  },
  mounted() {
    this.get_terms_and_conditions();

    // Check if consent was previously given
    const user_state = localStorage.getItem('user_state');
    if (user_state === 'consent_given') {
      this.consent_provided = true;
    }
  },
  watch: {
    get_consent(consent) {
      if (consent) {
        this.hide_popup();
      } else {
        this.show_popup();
      }
    },
    showCamera(newValue) {
      this.$emit('camera-state-changed', newValue)
    }
  },
};
